import { createI18n } from 'vue-i18n'
import en from './en-us'

export type SupportedLocale = 'en-us' | 'en-gb' | 'es-es' | 'pt-br' | 'bg-bg' | 'pl-pl' | 'fr-fr' | 'it-it' | 'de-de' | 'ru-ru' | 'zh-cn' | 'tr-tr' | 'ko-kr' | 'cs-cz' | 'hu-hu' | 'ro-ro' | 'uk-ua' | 'nl-nl'

export const SUPPORTED_LOCALES: SupportedLocale[] = ['en-us', 'en-gb', 'es-es', 'pt-br', 'bg-bg', 'pl-pl', 'fr-fr', 'it-it', 'de-de', 'ru-ru', 'zh-cn', 'tr-tr', 'ko-kr', 'cs-cz', 'hu-hu', 'ro-ro', 'uk-ua', 'nl-nl']

export const LOCALE_FLAG_KEY = 'setting_locale'

export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  'en-us': 'English (USA)',
  'en-gb': 'English (UK)',
  'es-es': 'Español',
  'pt-br': 'Português (Brasil)',
  'bg-bg': 'Български',
  'pl-pl': 'Polski',
  'fr-fr': 'Français',
  'it-it': 'Italiano',
  'de-de': 'Deutsch',
  'ru-ru': 'Русский',
  'zh-cn': '简体中文',
  'tr-tr': 'Türkçe',
  'ko-kr': '한국어',
  'cs-cz': 'Čeština',
  'hu-hu': 'Magyar',
  'ro-ro': 'Română',
  'uk-ua': 'Українська',
  'nl-nl': 'Nederlands'
}

export const i18n = createI18n({
  legacy: false,
  locale: 'en-us',
  fallbackLocale: 'en-us',
  messages: { 'en-us': en },
  missingWarn: false,
  fallbackWarn: false,
  numberFormats: {
    'en-us': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'en-gb': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'es-es': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'pt-br': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'bg-bg': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'pl-pl': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'fr-fr': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'it-it': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'de-de': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'ru-ru': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'zh-cn': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'tr-tr': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'ko-kr': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'cs-cz': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'hu-hu': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'ro-ro': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'uk-ua': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    },
    'nl-nl': {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      },
      compact: {
        notation: 'compact' as const,
        compactDisplay: 'short' as const
      }
    }
  },
  datetimeFormats: {
    'en-us': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'en-gb': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'es-es': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'pt-br': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'bg-bg': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'pl-pl': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'fr-fr': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'it-it': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'de-de': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'ru-ru': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'zh-cn': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'tr-tr': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'ko-kr': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'cs-cz': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'hu-hu': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'ro-ro': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'uk-ua': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    },
    'nl-nl': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      },
      time: {
        hour: '2-digit',
        minute: '2-digit'
      }
    }
  }
})

// Pre-define locale modules for Vite to bundle correctly
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const localeModules = import.meta.glob<{ default: any }>('./**/index.ts')

/**
 * Load a locale dynamically (for lazy loading additional languages)
 */
export async function loadLocale(locale: SupportedLocale): Promise<void> {
  if (i18n.global.availableLocales.includes(locale)) {
    return
  }

  const modulePath = `./${locale}/index.ts`
  const loader = localeModules[modulePath]
  if (!loader) {
    console.error(`Locale module not found: ${modulePath}`)
    return
  }
  const messages = await loader()
  i18n.global.setLocaleMessage(locale, messages.default)
}

/**
 * Set the active locale with lazy loading support
 */
export async function setLocale(locale: SupportedLocale): Promise<void> {
  await loadLocale(locale)
  i18n.global.locale.value = locale
  document.documentElement.setAttribute('lang', locale)
  localStorage.setItem('galexion-locale', locale)
}

/**
 * Set locale synchronously (only works for already-loaded locales)
 * Use this during app initialization to avoid race conditions
 */
export function setLocaleSync(locale: SupportedLocale): void {
  if (i18n.global.availableLocales.includes(locale)) {
    i18n.global.locale.value = locale
    document.documentElement.setAttribute('lang', locale)
    localStorage.setItem('galexion-locale', locale)
  }
}

/**
 * Get the initial locale from storage or browser preference
 */
export function getInitialLocale(): SupportedLocale {
  // Check localStorage first
  const stored = localStorage.getItem('galexion-locale') as SupportedLocale | null
  if (stored && SUPPORTED_LOCALES.includes(stored)) {
    return stored
  }

  // Check browser language - first try exact match (e.g., 'pt-br')
  const browserLang = navigator.language.toLowerCase()
  if (SUPPORTED_LOCALES.includes(browserLang as SupportedLocale)) {
    return browserLang as SupportedLocale
  }

  // Then try matching by language code (e.g., 'pt' matches 'pt-br')
  const langCode = browserLang.split('-')[0]
  const matchedLocale = SUPPORTED_LOCALES.find(
    (locale) => locale.startsWith(langCode + '-')
  )
  if (matchedLocale) {
    return matchedLocale
  }

  // Default to English
  return 'en-us'
}

/**
 * Initialize locale synchronously during app startup
 * Falls back to 'en-us' if preferred locale isn't pre-loaded
 */
export function initLocale(): void {
  const locale = getInitialLocale()
  if (i18n.global.availableLocales.includes(locale)) {
    setLocaleSync(locale)
  } else {
    // Locale not pre-loaded, use default and load async in background
    setLocaleSync('en-us')
    setLocale(locale) // Fire and forget - will update when ready
  }
}

/**
 * Get locale from browser preferences (auto-detection)
 */
export function detectBrowserLocale(): SupportedLocale {
  // Try exact match (e.g., 'pt-br')
  const browserLang = navigator.language.toLowerCase()
  if (SUPPORTED_LOCALES.includes(browserLang as SupportedLocale)) {
    return browserLang as SupportedLocale
  }

  // Try matching by language code (e.g., 'pt' matches 'pt-br')
  const langCode = browserLang.split('-')[0]
  const matchedLocale = SUPPORTED_LOCALES.find(
    (locale) => locale.startsWith(langCode + '-')
  )
  if (matchedLocale) {
    return matchedLocale
  }

  // Default to English
  return 'en-us'
}

/**
 * Sync locale with player flags after authentication.
 * - If player has setting_locale flag, apply it
 * - If no flag exists, auto-detect from browser and save to flag
 *
 * @param getFlag - Function to get a flag value
 * @param setFlag - Function to set a flag value (async)
 */
export async function syncLocaleWithPlayerFlags(
  getFlag: (key: string) => string | undefined,
  setFlag: (key: string, value: string) => Promise<void>
): Promise<void> {
  const savedLocale = getFlag(LOCALE_FLAG_KEY)

  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale as SupportedLocale)) {
    // Player has a saved locale preference - apply it
    const locale = savedLocale as SupportedLocale
    if (i18n.global.locale.value !== locale) {
      await setLocale(locale)
    }
  } else {
    // No saved locale - auto-detect and save to player flag
    const detectedLocale = detectBrowserLocale()
    await setLocale(detectedLocale)
    await setFlag(LOCALE_FLAG_KEY, detectedLocale)
  }
}

// Export the global t function for use outside of components
export const t = i18n.global.t
export const n = i18n.global.n
export const d = i18n.global.d
